// extracted by mini-css-extract-plugin
module.exports = {"project-tech-list":"ProjectTech_project-tech-list__1sUPo"};